import { render, staticRenderFns } from "./squadkaoqinginfomodel.vue?vue&type=template&id=163c8708"
import script from "./squadkaoqinginfomodel.vue?vue&type=script&lang=js"
export * from "./squadkaoqinginfomodel.vue?vue&type=script&lang=js"
import style0 from "./squadkaoqinginfomodel.vue?vue&type=style&index=0&id=163c8708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports